import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { NavigationContextService } from '@fg-services/navigation-context/navigation-context.service';
import {
  ConventionRole,
  conventionRoleResolver
} from '@fg-services/navigation-context/segments/convention-segment';
import { NavigableModel } from '@fg-services/navigation-context/segments/navigation-context-segment';
import { UserService } from '@fg-services/user.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Allows super admins, event admins of the convention in the route and admins of
 * its organization / community (they resolve to ConAdmin). Moderators are sent back.
 */
@Injectable()
export class ConventionAdminGuard implements CanActivate {
  constructor(
    private userServ: UserService,
    private navigationContextService: NavigationContextService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.userServ.isAuthenticated().pipe(
      map(isAuth => {
        if (!isAuth) return this.router.createUrlTree(['/']);
        // Same nested model lookup the navigation context uses to resolve roles
        const nestedModelIds = new Map<NavigableModel, string>();
        route.pathFromRoot.forEach(({ data, params }) => {
          if (data?.segmentName != null && params?.id) {
            nestedModelIds.set(data.segmentName, params.id);
          }
        });
        const conventionId = nestedModelIds.get(NavigableModel.Convention);
        const role = conventionRoleResolver(
          conventionId,
          this.navigationContextService,
          nestedModelIds
        );
        if (role === ConventionRole.Admin || role === ConventionRole.ConAdmin) return true;
        return this.router.createUrlTree(['/bs']);
      })
    );
  }
}
